// Remove any special characters and spaces from org name
// org name comes from PropelAuth -- it has alphanumeric characters, spaces, and underscores
export const emailUsernameFromOrg = (orgName: string) =>
  orgName
    // Remove any special characters except underscores
    .replace(/[^a-zA-Z0-9_ ]/g, '')
    // Replace spaces with dashes (spaces are not allowed in emails)
    // We used to use periods instead of dashes here, but our email server ignores them which caused clashes
    .replaceAll(' ', '-')
    .toLowerCase()
    .trim();
